import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {DocumentCurrency} from '../model/Entities/DocumentCurrency';

@Injectable()
export class DocumentCurrencyService extends ApiService<DocumentCurrency> {

    protected apiUrl = 'api/document-currency';  // URL to web api

    protected getObjectType(): any {
        return DocumentCurrency;
    }
}



// WEBPACK FOOTER //
// /app/src/services/document-currency.service.ts